/**
 * Meta.jsx
 * ---------------------------------------------------------------------------
 * Small label + value pair used throughout intake result views and metadata
 * displays. Uppercase label + clean body value.
 */

import React from "react";
import { tokens } from "../../lib/tokens.js";

export default function Meta({ label, value }) {
  return (
    <div>
      <div
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 11,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: tokens.inkSoft,
          marginBottom: 8,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: 15,
          color: tokens.ink,
          lineHeight: 1.55,
        }}
      >
        {value}
      </div>
    </div>
  );
}
